// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2hBKu","text":"SelectPayment_text__d92Y3","title":"SelectPayment_title__sRjcM","btn":"SelectPayment_btn__1AALo"};